export default __webpack_public_path__ + "static/media/22.be8594a8.svg";